<div id="hotels" name="search-hotels" class="filtro-flotanteH tab-panel">
  <div style="display: flex; justify-content: center; align-content: center">
    <h1 innerHTML="{{'SEARCH.soon'|translate}}">
      Soon
    </h1>
  </div>
</div>